import type { FC } from 'react';

import { css } from '@styled-system/css';

import type { AnalysisPlatform } from '@/shared/api/types/generated';
import vestiaireLogo from '@/shared/assets/platforms/vestiaire.png';
import vintedLogo from '@/shared/assets/platforms/vinted.png';

// Plateformes CONNUES (exclut le membre `%future added value` ajouté par le codegen, cf
// `catalogTree.ts`) : une nouvelle plateforme ajoutée au schéma sans logo ne compile pas.
type KnownPlatform = Exclude<AnalysisPlatform, '%future added value'>;

// Icônes carrées officielles des plateformes (favicons de vinted.fr et vestiairecollective.com,
// réduites à 64 px — nettes jusqu'à 32 px affichés).
const PLATFORM_LOGOS: Record<KnownPlatform, string> = {
  vinted: vintedLogo,
  vestiaire: vestiaireLogo,
};

const isKnownPlatform = (platform: AnalysisPlatform): platform is KnownPlatform => platform in PLATFORM_LOGOS;

const logo = css({ flexShrink: 0, borderRadius: 'sm', objectFit: 'cover', display: 'block' });

interface PlatformLogoProps {
  platform: AnalysisPlatform;
  /** Côté en pixels (carré). */
  size?: number;
}

/** Logo de plateforme, décoratif : le nom de la plateforme est toujours écrit à côté. */
export const PlatformLogo: FC<PlatformLogoProps> = ({ platform, size = 20 }) =>
  isKnownPlatform(platform) ? (
    <img src={PLATFORM_LOGOS[platform]} alt="" aria-hidden width={size} height={size} className={logo} />
  ) : null;
